/*
 * Truffle Kit — Puffy Bag color (line item property "Bag Color").
 * Bag color is chosen in the cart/drawer via selectable boxes (see the
 * kit-bag-color snippet), not as a product option (client spec).
 *
 * Notes on the shape of this code:
 * - Buttons (type="button") fire no 'change' events, so the theme's
 *   <cart-items> change listener never sees these interactions.
 * - The POST omits `quantity` so a concurrent quantity update can't be reverted.
 * - After a successful save the cart surface is re-rendered: a property change
 *   gives the line item a NEW key, so the DOM must be re-stamped (the selected
 *   box is marked server-side from the saved property). If the re-render fails,
 *   fall back to a full reload — never leave stale keys behind.
 * - On a FAILED save nothing is marked selected: the checkout gate trusts the
 *   server-stamped .is-selected state, which only exists for saved colors.
 * - URLs go through window.routes so localized storefronts keep their prefix.
 */
(function () {
  if (window.kitBagColorInit) return;
  window.kitBagColorInit = true;

  var pendingSaves = 0;

  function routesUrl(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function setCheckoutDisabled(disabled) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      if (disabled) {
        btn.setAttribute('data-kit-wait', 'true');
        btn.disabled = true;
      } else if (btn.getAttribute('data-kit-wait') === 'true') {
        btn.removeAttribute('data-kit-wait');
        btn.disabled = false;
      }
    });
  }

  function refreshCartSurface(el) {
    var drawer = el && el.closest('#mini-cart');
    if (drawer) {
      var rootUrl = routesUrl('root_url', '/');
      var joiner = rootUrl.slice(-1) === '/' ? '' : '/';
      return fetch(rootUrl + joiner + '?section_id=mini-cart')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.shopify-section');
          if (!fresh) throw new Error('Drawer refresh returned no section');
          drawer.innerHTML = fresh.innerHTML;
        });
    }
    // Cart page: reload so the items list, footer (dynamic checkout buttons)
    // and line-item keys are all consistent again.
    window.location.reload();
    return Promise.resolve();
  }

  // Save the clicked color as the line's "Bag Color" property.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.kit-bag-color__option');
    if (!btn) return;
    var group = btn.closest('[data-kit-bag-group]');
    if (!group || btn.classList.contains('is-selected') || btn.disabled) return;

    var key = group.dataset.itemKey;
    var value = btn.dataset.value;
    var buttons = group.querySelectorAll('.kit-bag-color__option');
    group.classList.remove('kit-bag-color--error');
    buttons.forEach(function (b) { b.disabled = true; });
    pendingSaves++;
    setCheckoutDisabled(true);

    fetch(routesUrl('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (i) { return i.key === key; });
        if (!line) {
          // Stale key (a previous property change re-keyed the line):
          // fall back to the only kit line with this variant prefix.
          var variantPrefix = key.split(':')[0] + ':';
          var candidates = cart.items.filter(function (i) { return i.key.indexOf(variantPrefix) === 0; });
          if (candidates.length === 1) line = candidates[0];
        }
        if (!line) throw new Error('Cart line not found');
        var props = Object.assign({}, line.properties || {});
        props['Bag Color'] = value;
        return fetch(routesUrl('cart_change_url', '/cart/change') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, properties: props })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart update failed');
        // Save succeeded — the re-render stamps the selected box server-side.
        // Refresh failures must not read as save failures.
        return refreshCartSurface(group).catch(function () {
          window.location.reload();
        });
      })
      .catch(function (err) {
        console.error('Bag color update failed:', err);
        buttons.forEach(function (b) { b.disabled = false; });
        alert(group.getAttribute('data-msg-error') || 'Could not save the bag color. Please try again.');
      })
      .finally(function () {
        pendingSaves = Math.max(0, pendingSaves - 1);
        if (pendingSaves === 0) setCheckoutDisabled(false);
      });
  });

  // Block checkout while any kit line has no saved bag color, or a save is in
  // flight. (Accelerated checkout buttons are handled server-side:
  // main-cart-footer.liquid hides them while a kit line has no Bag Color.)
  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    // e.submitter can be undefined in older engines — then gate any form that
    // contains a checkout button (with JS enabled, those forms only submit
    // via their checkout button anyway).
    var isCheckout = submitter
      ? submitter.name === 'checkout'
      : !!(e.target && e.target.querySelector && e.target.querySelector('[name="checkout"]'));
    if (!isCheckout) return;

    var missing = null;
    var missingHidden = null;
    document.querySelectorAll('[data-kit-bag-group]').forEach(function (g) {
      if (g.querySelector('.kit-bag-color__option.is-selected')) return;
      if (g.offsetParent !== null) {
        if (!missing) missing = g;
      } else if (!missingHidden) {
        missingHidden = g;
      }
    });
    // Prefer a visible group for feedback; a hidden one (closed drawer copy)
    // still blocks, since the property is genuinely missing.
    var blocker = missing || missingHidden;
    if (blocker) {
      e.preventDefault();
      e.stopPropagation();
      if (missing) {
        missing.classList.add('kit-bag-color--error');
        missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstOption = missing.querySelector('.kit-bag-color__option');
        if (firstOption) firstOption.focus();
      } else {
        alert(blocker.getAttribute('data-msg-required') || 'Please select a Puffy Bag color for your Truffle Kit before checking out.');
      }
      return;
    }
    if (pendingSaves > 0) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
